// extracted by mini-css-extract-plugin
module.exports = {"hideFocusVisible":"hide-focus-visible_hideFocusVisible__a_yA1"};